import { SPORT_NAMES, DAY_NAMES, MONTH_NAMES } from '../config';
import { formatTime } from '../utils';
import type { StravaActivity } from '../types';

interface Props {
  activities: StravaActivity[];
  stravaError: string | null;
}

export function WorkoutPanel({ activities, stravaError }: Props) {
  let content;

  if (stravaError) {
    if (stravaError.startsWith('http')) {
      content = <a class="strava-btn" href={stravaError} target="_blank" rel="noopener noreferrer">CONNECT STRAVA</a>;
    } else {
      content = <div class="w-empty">{stravaError}</div>;
    }
  } else if (activities.length === 0) {
    content = <div class="w-empty">Нет тренировок</div>;
  } else {
    content = (
      <div class="w-scroll">
        {activities.map((a, i) => {
          const tp = SPORT_NAMES[a.type] || a.type;
          const dt = new Date(a.start_date_local);
          const ds = `${dt.getDate()} ${MONTH_NAMES[dt.getMonth()]}, ${DAY_NAMES[dt.getDay()]}`;
          const dist = a.distance ? `${(a.distance / 1000).toFixed(1)} км` : '';
          return (
            <div key={i} class="w-card">
              <div class="w-sport">{tp}</div>
              <div class="w-time">{formatTime(a.moving_time)}</div>
              <div class="w-name">{a.name}</div>
              <div class="w-info">
                {ds}{dist ? ` / ${dist}` : ''}
                {' '}
                {a.has_heartrate && a.average_heartrate && (
                  <span class="w-hr">HR {Math.round(a.average_heartrate)}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div class="work-panel">
      <div class="wp-title">TRAINING LOG</div>
      {content}
    </div>
  );
}
